import SendEmail from "assets/images/Authentication/send-email.svg";
import { useFormik } from "formik";
import queryString from "query-string";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";
// import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { RouteConstants } from "routes/RouteConstants";
import { get } from "services/cookies";
import { getLocal, set } from "services/localStorage";
import * as Yup from "yup";
import AuthWrapper from "../components/AuthWrapper";
import DotLoaderCircle from "../components/DotLoaderCircle";
import { redirection_url } from "../constant";
import {
  handelSendMagicLink,
  handleLoginWithMagicLink,
} from "../store/actions";
import { isOrg } from "utils";

const initialValues = {
  password: "",
};

const validationSchema = Yup.object().shape({
  password: Yup.string().trim().required("Password is required."),
});

const Login = () => {
  const { verifyAccountLoading, verifyAccountData, magicLinkLoading } =
    useSelector(state => state.NewAuth);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const from = location.state?.from?.pathname;
  const query = queryString.parse(location.search);
  const redirect = query?.isFrom
    ? query?.redirect + "&isFrom=signup"
    : query?.redirect || query?.redirect_uri;
  const clientId = query?.client_id || "";
  const app_id = query?.app_id || "2";

  const queryParams = {
    utm_campaign: query.utm_campaign,
    utm_medium: query.utm_medium,
    utm_source: query.utm_source,
    utm_term: query.utm_term,
    utm_content: query.utm_content,
    sign_up: query.sign_up,
    partner: query.partner,
  };

  const filteredQueryParams = Object.fromEntries(
    Object.entries(queryParams).filter(
      ([key, value]) => value !== undefined && value !== null && value !== ""
    )
  );

  const updatedRedirectUrl =
    redirect +
    Object.keys(filteredQueryParams)
      .map(key => `&${key}=${filteredQueryParams[key]}`)
      .join("");

  useEffect(() => {
    if (!!redirect) {
      set("redirect_url", redirect);
      set("site_id", app_id);
      set("client_id", clientId);
      set("utm_params", updatedRedirectUrl);
      navigate(RouteConstants.login);
    }
  }, [redirect, app_id, clientId, navigate, updatedRedirectUrl]);

  const email = useMemo(() => {
    if (!!location.search) {
      let email = location.search?.split("email=");
      if (email.length > 1) return email[1]?.split("&")[0];
      return "";
    }
    return "";
  }, [location.search]);

  useEffect(() => {
    if (
      !location?.search ||
      (!!!location?.search && !email) ||
      !!!verifyAccountData
    ) {
      if (+query?.app_id === 15) {
        navigate(RouteConstants.home + `?sign_up=free-trial`);
      } else {
        navigate(RouteConstants.home);
      }
    }
  }, [email, location?.search, navigate, query?.app_id, verifyAccountData]);

  const submitLoginUser = data => {
    if (!!!email) {
      // toast.error("Something went's wrong");
      navigate(RouteConstants.home);
      return;
    }
    let payload = {
      email: email,
      password: data?.password,
      site_id: +process.env.REACT_APP_SITE_ID,
      isSSO: getLocal("client_id") ? true : false,
      via_portal: (+get("site_id"))?.toString() || "2",
      affiliate_visit_id: get("affiliate_visit_id") || 0,
      partner: query?.partner || "",
    };
    let removeRef = !!localStorage.getItem("source_page")
      ? ""
      : !!localStorage.getItem("redirect_url")
      ? localStorage.getItem("redirect_url")?.includes("?ref=vbs")
        ? localStorage.getItem("redirect_url")?.split("?ref=vbs")?.[0]
        : localStorage.getItem("redirect_url")
      : localStorage.getItem("redirect_url");
    console.log(from);
    dispatch(
      handleLoginWithMagicLink(
        payload,
        navigate,
        false,
        from,
        removeRef,
        query?.partner ? query.partner : null
      )
    );
  };

  const { values, errors, touched, handleSubmit, handleBlur, handleChange } =
    useFormik({
      initialValues,
      validationSchema,
      onSubmit: submitLoginUser,
    });

  const isAllDataAvailable = useMemo(() => {
    return !values?.password;
  }, [values?.password]);

  const handleSendLoginLink = () => {
    let payload = {
      user_id: +verifyAccountData?.user_id,
      email: verifyAccountData?.email,
      redirect_url: redirection_url,
      is_user_exists: verifyAccountData?.is_account,
      site_id: JSON.parse(localStorage.getItem("site_id"))
        ? JSON.parse(localStorage.getItem("site_id"))
        : "2",
      sign_up: query?.sign_up || "",
      partner: query?.partner || "",
    };
    if (isOrg) {
      payload.utm_campaign = query?.utm_campaign || "";
      payload.utm_medium = query?.utm_medium || "";
      payload.utm_source = query?.utm_source || "";
      payload.utm_content = query?.utm_content || "";
      payload.utm_term = query?.utm_term || "";
    }

    const cb = () => {
      query?.partner
        ? navigate(RouteConstants.resendLink + `?partner=${query.partner}`)
        : navigate(RouteConstants.resendLink);
    };
    dispatch(handelSendMagicLink(payload, cb));
  };

  return (
    <AuthWrapper>
      <div className="login-wrapper">
        <div className="header-wrapper">
          <h1 className="title">Log in with password</h1>
        </div>
        <div className="login-with-email-wrapper">
          <span className="login-with-email" onClick={handleSendLoginLink}>
            {magicLinkLoading ? (
              <Spinner size={"sm"} className="me-1" />
            ) : (
              <ReactSVG src={SendEmail} />
            )}
            or log in with an email link
          </span>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="body-wrapper">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter password"
              name="password"
              value={values?.password}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {touched?.password && errors?.password && (
              <div className="form-text text-danger">{errors?.password}</div>
            )}
          </div>
          <div className="footer-wrapper">
            <button
              type="submit"
              className="submit-button"
              disabled={verifyAccountLoading || isAllDataAvailable}
            >
              {verifyAccountLoading ? (
                <DotLoaderCircle text="Log in" />
              ) : (
                "Log in"
              )}
            </button>
            <div className="link-wrapper">
              <Link to={`${RouteConstants.forgetPassword}?email=${email}`}>
                I forgot my password
              </Link>
            </div>
          </div>
        </form>
      </div>
    </AuthWrapper>
  );
};

export default Login;
